import { AdviserSearchResult } from '~/api/adviser-search-api';
import { EmployerSearchResult } from '~/api/employer-search-api';
import { InvestmentManagerSearchResult } from '~/api/investment-manager-search-api';
import { MemberSearchResult } from '~/api/member-search-api';
import { EntityType } from '~/models/entities/entity-type';

export enum EntitySearchStatus {
	DEFAULT,
	IN_PROGRESS,
	SEARCH_SUCCESS,
	RETRIEVING_DATA,
	SELECTED,
}

export type EntitySearchType =
	| EmployerSearchResult
	| MemberSearchResult
	| InvestmentManagerSearchResult
	| AdviserSearchResult;

/**
 * FontAwesome icon displayed on the entity search bar
 *
 * NOTE: Please fill in the blanks as we support more entities
 * https://fontawesome.com/icons?d=gallery&s=regular,solid&m=free
 */
export const EntityIconClass: { [key in EntityType]: string } = {
	EMPTY: 'fas fa-user',
	MEMBER: 'fas fa-user',
	EMPLOYER: 'fas fa-user-tie',
	INVESTMENT_MANAGER: 'fas fa-user-clock',
	ADVISER: 'fas fa-user-friends',
};
